import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@hq-core/models/app-settings';
import { Feedback } from '@hq-core/models/feedback';
import { DataResource } from '@hq-custom-types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SupportRequestResource implements DataResource<Feedback> {
    private readonly baseUrl: string;

    constructor(private http: HttpClient, private appSettings: AppSettings) {
        this.baseUrl = `${this.appSettings.apis.user}/send-support`;
    }

    create(feedback: Feedback): Observable<Feedback> {
        const url = this.baseUrl;
        return this.http.post<Feedback>(url, feedback);
    }
}
